import React from 'react';
import './style.scss';

export function SignInButtonsBox({ children }: any) {
	return <section className="Sign-In-Buttons-Box">
		{ children }
	</section>
}
